import { render, staticRenderFns } from "./ConfirmImageModal.vue?vue&type=template&id=5f8bc6d2&scoped=true&"
import script from "./ConfirmImageModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmImageModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmImageModal.vue?vue&type=style&index=0&id=5f8bc6d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8bc6d2",
  null
  
)

export default component.exports